import { fromJS, Map } from 'immutable';
import { Instructio } from './../../Record/Tickets/';

const NAME_SPACE = 'TICKETS/INSTRUCTIO';

const initialState = new Map({
  pageSize: 0,
  currentPage: 0,
  count: 0,
  data: fromJS([]),
  loading: false,
  item: new Instructio({}),
});

const item = (state, action) => {
  switch (action.type) {
    case NAME_SPACE + 'V_LOADING':
      return state.update('loading', loading => action.payload.state);
    case NAME_SPACE + 'ADD':
      if (action.payload.instructio.key > 0) return state;
      return state.update('data', data => data.insert(0, action.payload.instructio));
    case NAME_SPACE + 'DEL':
      return state.update('data', data => {
        return data.delete(data.findIndex(x => x.get('key') === action.payload.key));
      });
    case NAME_SPACE + 'SAVE':
      return state.update('data', data => {
        return data.update(data.findIndex(x => x.get('key') === action.payload.instructio.key), instructio => {
          return instructio.merge(action.payload.instructio);
        });
      });
    case NAME_SPACE + 'GET_ITEM':
      return state.update('item', () => {
        return state.get('data').get(state.get('data').findIndex(x => x.get('key') === action.payload.key));
      });
    case NAME_SPACE + 'RECEIVE_STOCK_TICKETS_INSTRUCTIO':
      return fromJS({ ...action.payload, ...{ item: new Instructio({}) } });
    default:
      return state;
  }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case NAME_SPACE + 'V_LOADING':
      return item(state, action);
    case NAME_SPACE + 'ADD':
      return item(state, action);
    case NAME_SPACE + 'DEL':
      return item(state, action);
    case NAME_SPACE + 'SAVE':
      return item(state, action);
    case NAME_SPACE + 'GET_ITEM':
      return item(state, action);
    case NAME_SPACE + 'RECEIVE_STOCK_TICKETS_INSTRUCTIO':
      return item(state, action);
    default:
      return state;
  }
};